import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReportsService } from '@services/reports.service';
import { DatepickerDropdownComponent, DateTimeService, EditorComponentBase } from 'ngx-lib';
import { Subscription } from 'rxjs';

interface DateRange {
    from?: Date;
    to?: Date;
    includeEmpty?: boolean;
}

@Component({
    selector: 'app-date-range-editor',
    templateUrl: './date-range-editor.component.html',
    styleUrls: ['./date-range-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatepickerDropdownComponent]
})
export class DateRangeEditorComponent extends EditorComponentBase<DateRange | null> implements OnInit, OnDestroy {
    selectedDate: DateRange;
    rangeDirection?: 'forward' | 'backward' | 'both';
    subscription?: Subscription;

    constructor(
        readonly dateTimeService: DateTimeService,
        private reportsService: ReportsService
    ) {
        super();
        this.selectedDate = {
            from: undefined,
            to: undefined
        };
    }
    ngOnInit(): void {
        this.rangeDirection = this.additionalInfo?.rangeDirection;
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty) {
                this.selectedDate = { from: this.bindingProperty.from, to: this.bindingProperty.to };
                this.formatDate(this.selectedDate);
                if (this.bindingProperty.includeEmpty) {
                    this.selectedDate.includeEmpty = this.bindingProperty.includeEmpty;
                }
            }
        });
    }

    formatDate(date: DateRange) {
        if (date.to) {
            this.selectedDate.to = this.dateTimeService.formatDateTimeToDate(
                this.dateTimeService.getDateTimeFromString(date.to.toString())
            );
        }
        if (date.from) {
            this.selectedDate.from = this.dateTimeService.formatDateTimeToDate(
                this.dateTimeService.getDateTimeFromString(date.from.toString())
            );
        }
    }

    onSelectedDateChange() {
        if (this.selectedDate && this.bindingProperty) {
            this.bindingProperty.from = this.selectedDate.from;
            this.bindingProperty.to = this.selectedDate.to;
            this.validate();
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    onCheckboxChange(val: boolean) {
        if (this.bindingProperty) this.bindingProperty.includeEmpty = val;
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
